import { useEffect, useState } from 'react';
import { RectangleSelector } from 'react-image-annotation/lib/selectors';
import Immutable from 'immutable';

// Transform
const getDraggableAnnotations = (blockData) => {
  return blockData.draggables.map((draggable) => {
    const geometry = {
      x: draggable.x_position,
      y: draggable.y_position,
      type: RectangleSelector.TYPE,
      width: draggable.width,
      height: draggable.height,
    };

    const id = draggable.id || Immutable.Map(geometry).hashCode();

    return {
      id,
      isDraggable: true,
      data: {
        ...draggable,
        id,
      },
      geometry,
    };
  });
};

const getDropzoneAnnotations = (blockData) => {
  return blockData.dropzones.map((dropzone) => {
    const geometry = {
      x: dropzone.x_offset,
      y: dropzone.y_offset,
      type: RectangleSelector.TYPE,
      width: dropzone.width,
      height: dropzone.height,
    };

    const id = dropzone.id || Immutable.Map(geometry).hashCode();

    return {
      id,
      isDraggable: false,
      targetAnnotationIds: [], // TBC
      data: {
        ...dropzone,
        correctAnswerValue: dropzone.value || '',
        id,
      },
      geometry,
    };
  });
};

export const useDragAndDropImage = (
  blockData,
  onBlockResponseChange,
  blockResponse
) => {
  const [imageUrl, setImageUrl] = useState(blockData.image_url);
  const [draggableAnnotations, setDraggableAnnotations] = useState(
    getDraggableAnnotations(blockData)
  );
  const [dropzoneAnnotations, setDropzoneAnnotations] = useState(
    getDropzoneAnnotations(blockData)
  );

  const [
    draggableToContainingDropzoneMap,
    setDraggableToContainingDropzoneMap,
  ] = useState(blockResponse.draggable_to_containing_dropzone_map || {});

  const onDraggableRelocated = (draggableId, dropzoneId) => {
    setDraggableToContainingDropzoneMap({
      ...draggableToContainingDropzoneMap,
      [draggableId]: dropzoneId,
    });

    onBlockResponseChange({
      'draggable_to_containing_dropzone_map': {
        ...draggableToContainingDropzoneMap,
        [draggableId]: dropzoneId,
      },
    });
  };

  // This ensures useEffect is run to keep annotations in sync
  const blockDataHashCode = Immutable.Map(blockData).hashCode();

  useEffect(() => {
    setDraggableAnnotations(getDraggableAnnotations(blockData));
    setDropzoneAnnotations(getDropzoneAnnotations(blockData));
    setImageUrl(blockData.image_url);
  }, [blockDataHashCode, blockData]);

  return {
    draggableAnnotations,
    dropzoneAnnotations,
    imageUrl,
    draggableToContainingDropzoneMap,
    onDraggableRelocated,
  };
};
